<template lang="pug">
    ModelBasic(:show-left="showForm" :status="status" :error-info="errorInfo"  @download="toDownloadPdf" :download="download" :download-resource="false")
        template(slot="left-title")
            .form-title(:class="titleClass")
        template(slot="left-content")
            .form-container
                el-form.form(ref="form", :model="model", v-if="model && model.parameters")
                    el-form-item(
                        v-for="(item, index) in model.parameters",
                        :rules="rules[item.data_type] || rules['string']",
                        :key="`${item.name}_${item.key_type}`",
                        :prop="'parameters.' + index + '.value'")
                        .name {{item.display}}
                        GroupTitle(v-if="item.data_type === 'title'" :title="item.title" :tip="item.tip")
                        el-input.gzzoc-input(type="text", v-model="item.value", v-else-if="item.data_type === 'number'", :placeholder="$t('gzzoc.numberPlease')")
                        el-input.gzzoc-input(type="text", v-model="item.value", v-else, :placeholder="$t('gzzoc.contentPlease')")
        template(slot="left-footer")
            .form-footer
                el-button.gzzoc-button-primary.submit-btn(type="primary", @click="submit", :disabled="status === 'executing'") {{$t('startAnalysis')}}
                el-button.gzzoc-button-secondary.reset-btn(type="primary" @click="reset") {{$t('reset')}}
        template(slot="right-content")
            .right-content
                .main
                    .sub-title {{$t('gzzoc.fiveYearResult', {year: result.ttl})}}
                    .result-eye
                        .item(v-for="item in result.report")
                            .eye {{item.side}}
                            .degree {{item.value}}
                            .level
                                span(:class="getEyeLevelClass(item.value)") {{item.explain}}
                            .result(:class="{danger: item.value < -6.0}") {{item.value < -6.0 ? $t('gzzoc.myopiaHighRisk') : $t('gzzoc.myopiaLowRisk')}}
                .footer
                    .hint
                        span {{$t('gzzoc.normalRange')}}：-0.5 ~ +0.5
                        span {{$t('gzzoc.qingdu')}}：<-0.5
                        span {{$t('gzzoc.gaodu')}}：<-6.0
                        span {{$t('gzzoc.yuanshi')}}：>+0.5
                    .tip {{$t('gzzoc.myopiaTip')}}
        template(slot="right-tips")
            .right-tips
                .tip-title {{$t('projectDesc')}}
                .tip-content(v-html='modelData.model_remark')

                .tip-title {{$t('reference')}}
                .tip-content
                    p(v-for="item in modelData.reference_documents")
                        a(:href="item.value", v-if="item.name === 'url'", target="_blank") {{item.value}}
                        span(v-else) {{item.value}}
</template>

<script>
import Logo from 'components/logo';
import UserNav from 'components/user-nav';
import UtilMixins from '@/mixins/utils';
import GzzocModelMixin from './gzzoc-model-mixin';
import GroupTitle from '../components/group-title';
import ModelBasic from './gzzoc-model-basic';
import { languages, i18n } from "@/locale";
import _ from 'lodash';
import ls from '@/utils/local-storage';

export default {
    data () {
        return {
            languages: languages,
            loading: {
                executing: false
            },
            download: {
                loading: false,
                locked: false
            },
            model: {
                parameters: []
            },
            status: 'not_start',
            errorInfo: '',
            modelData: {
                "model_id": "",
                "parameter_list": [{
                    "name": "参数1",
                    "default": 99,
                    "type": "number",
                    "value": ""
                }, {
                    "name": "参数2",
                    "default": true,
                    "type": "string",
                    "value": ""
                }, {
                    "name": "参数3",
                    "default": 99,
                    "type": "number",
                    "value": ""
                }, {
                    "name": "参数4",
                    "default": true,
                    "type": "number",
                    "value": ""
                }, {
                    "name": "参数5",
                    "default": 99,
                    "type": "number",
                    "value": ""
                }],
                "desease_id": "",
                "status": 1

            },
            rules: {
                string: [
                    {
                        required: true,
                        trigger: ['change'],
                        message: '　'
                    }
                ],
                number: [
                    {
                        trigger: ['blur', 'change'],
                        validator (rules, value, callback) {
                            if (value === undefined || value === '' || isFinite(+value)) {
                                callback();
                            } else {
                                callback(new Error('　'));
                            }
                        }
                    },
                    {
                        required: true,
                        trigger: ['change'],
                        message: '　'
                    }
                ],
                title: []
            },
            result: {
                report: []
            }
        };
    },
    mixins: [UtilMixins, GzzocModelMixin],
    components: {
        Logo,
        UserNav,
        GroupTitle,
        ModelBasic,
    },
    computed: {
        id () {
            return this.$route.params.id;
        },
        lang () {
            return _.find(languages, {lang: this.$i18n.locale}) || languages[0];
        },
        titleClass () {
            let cls = ls.get('lang');
            return {
                'cn': cls === 'zh-CN',
                'en': cls === 'en'
            };
        },
        showForm () {
            return _.get(this.model, 'parameters', []).length > 0;
        }
    },
    mounted () {
        this.getData();
    },
    destroyed () {
        clearTimeout(this.timer)
    },
    methods: {
        getData () {
            this.model.parameters = [];
            this.$http.get('mli/predict_model/model', {
                params: {
                    model_id: this.id
                }
            }).then(resp => {
                this.modelData = _.get(resp, 'body.value.data');
                // this.model.parameters = this.modelData.parameter_list;
                this.model.parameters = this.formatParameters(this.modelData.parameters, 'gzzoc.imgTipData');
            });
        },
        submit () {
            let parameters = this.getParameterValue(this.model.parameters);
            for (let k in parameters) {
                for (let ki in parameters[k]) {
                    let val = parameters[k][ki].value;
                    if (val === undefined || val === null || Number.isNaN(val)) {
                        parameters[k] = [];
                        break;
                    }
                }
            }
            if (_.get(parameters, 'public', []).length === 0 ||
                (_.get(parameters, 'left_eye', []).length === 0 &&
                _.get(parameters, 'right_eye', []).length === 0)) {
                this.$message.error(i18n.t('message.checkInput'));
                return;
            }
            this.status = 'executing';
            this.$http.post('mli/predict_model/create_task', {
                model_id: this.id,
                parameters
            }).then(resp => {
                // console.log(this.model.parameters);
                if (_.get(resp, 'body.value.code') !== 0) {
                    let errorInfo = _.get(resp, 'body.value.error');
                    this.status = 'failed';
                    this.$message.error(errorInfo);
                    this.errorInfo = errorInfo;
                    return;
                }
                this.task_id = _.get(resp, 'body.value.data.task_id');
                if (Array.isArray(this.task_id) && this.task_id.length === 0) {
                    this.status = 'failed';
                }
                this.getResult();
            });
        },
        getResult () {
            if (!this.task_id) {
                this.status = 'not_start';
                return;
            }
            clearTimeout(this.timer);
            let taskId = Array.isArray(this.task_id) ? this.task_id.join('|') : this.task_id;
            this.$http.get('mli/predict_model/task_result', {
                params: {
                    task_id: taskId
                }
            }).then(resp => {
                if (_.get(resp, 'body.value.code') !== 0) {
                    let errorInfo = _.get(resp, 'body.value.error');
                    this.status = 'failed';
                    this.$message.error(errorInfo);
                    this.errorInfo = errorInfo;
                    return;
                }
                const status = _.get(resp, 'body.value.data.status');
                // 成功
                if (status === 'completed') {
                    const result = _.get(resp, 'body.value.data.results', {});
                    this.result = result;
                    this.date = result.date;
                    this.status = 'success';
                    return;
                }

                // 失败
                if (status === 'failed') {
                    let errorInfo = _.get(resp, '[body.value.data.error_info[0]', this.$t('gzzoc.execFailed'));
                    this.status = 'failed';
                    this.$message.error(errorInfo);
                    this.errorInfo = errorInfo;
                    return;
                }
                this.timer = setTimeout(() => {
                    this.getResult();
                }, 3000);
            });
        },
        reset () {
            _.forEach(_.get(this, 'model.parameters', []), model => {
                this.$set(model, 'value', '');
            });
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        getEyeLevelClass (n) {
            return {
                'far': n > 0.5,
                'normal': n >= -0.5 && n <= 0.5,
                'light': n < -0.5 && n >= -6,
                'high': n < -6,
            };
        },
        toDownloadPdf () {
            let taskId = Array.isArray(this.task_id) ? this.task_id.join('|') : this.task_id;
            this.downloadPdf(taskId, "eyeprint", this.date, this.download);
        }
    }
};
</script>

<style lang="sass" scoped>
    .form-title
        width: 100%
        height: 48px
        margin-top: 24px
        background-repeat: no-repeat
        &.cn
            background-image: url(~public/images/gzzoc/myopia-cn.svg)
        &.en
            background-image: url(~public/images/gzzoc/myopia-en.svg)
    .form-container
        padding: 20px
        overflow: auto
        flex: 1 1 auto
        width: 400px
        .name
            line-height: 1.4
            font-family: PingFangSC-Regular
            font-size: 14px
            color: #666
            margin-bottom: 10px
            white-space: nowrap
    .form-footer
        padding: 20px 20px
        text-align: center
        height: 90px
        .submit-btn
            width: 232px
            height: 40px
        .reset-btn
            width: 104px
            height: 40px
            margin-left: 16px

    .info
        font-size: 12px
        .info-content
            color: rgba(#fff, 0.8)
            text-overflow: ellipsis
            white-space: nowrap
            overflow: hidden
            line-height: 20px
            margin-right: 50px
            vertical-align: middle
            margin-top: 5px

    .right-content
        .main
            .sub-title
                font-family: PingFangSC-Semibold
                font-size: 24px
                color: #333
                text-align: center
                margin-top: 24px
            .result-eye
                display: flex
                justify-content: center
                margin-top: 32px
                .item
                    padding-left: 40px
                    padding-right: 40px
                    &:not(:first-child)
                        border-left: 1px solid #999
                    .eye,
                    .degree,
                    .level
                        text-align: center
                    .eye
                        font-family: PingFangSC-Regular
                        font-size: 14px
                        color: #333
                        text-align: center
                    .degree
                        font-family: DIN-Medium
                        font-size: 60px
                        line-height: 73px
                        color: #4E5876
                        letter-spacing: 0
                        text-align: center
                        height: 73px
                        margin-top: 8px
                    .level
                        font-family: PingFangSC-Regular
                        font-size: 14px
                        letter-spacing: 0
                        text-align: center
                        height: 24px
                        line-height: 24px
                        margin-top: 18px
                        span
                            display: inline-block
                            border-radius: 2px
                            padding: 0px 15px
                            &.normal
                                background-color: #BEEACD
                                color: #2A6840
                            &.light
                                background-color: #FFE2B2
                                color: #6D4A0F
                            &.high
                                background-color: #FFC8C8
                                color: #5C1B33
                            &.far
                                background-color: #BCE2FE
                                color: #1F4777
                    .result
                        font-family: PingFangSC-Semibold
                        font-size: 20px
                        color: #333
                        text-align: center
                        margin-top: 34px
                        &.danger
                            color: #FF4A4A
        .footer
            .hint
                display: inline-block
                height: 36px
                line-height: 36px
                padding-left: 16px
                padding-right: 16px
                background-color: #EEE
                border-radius: 8px
                margin-top: 24px
                position: relative
                left: 50%
                transform: translateX(-50%)
                span
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #666
                    &:not(:last-child)
                        margin-right: 24px
            .tip
                font-family: PingFangSC-Regular
                font-size: 14px
                color: #666666
                text-align: center
                margin-top: 16px
    .right-tips
        background: none
        padding: 20px 20px 0
        font-size: 12px
        line-height: 1.4
        color: rgba(#fff, .6)
        border-radius: 8px
        .tip-title
            font-family: PingFangSC-Semibold
            font-size: 16px
            line-height: 22px
            color: #333
            letter-spacing: 0.46px
            text-align: justify
            &:not(:first-child)
                margin-top: 16px
        .tip-content
            font-family: PingFangSC-Regular
            font-size: 14px
            line-height: 20px
            color: #333
            letter-spacing: -0.1px
            text-align: justify
            margin-top: 8px
            p
                margin-top: 5px

</style>
